module.exports = __webpack_public_path__ + "images/1.1789440611829.jpg";